import React from 'react';
import {
    AutoComplete,
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Icon,
    Input,
    message,
    Row,
    Select,
    Spin,
    Tooltip
} from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {inEditMode} from "../../redux/actions/global";
import {patchEventHeader} from "../../services/evt";
import moment from 'moment';
import CkUpload from "../../components/CkUpload";
import EvtSummaryEditor from "../../components/EvtSummaryEditor";
import EvtAddressMap from "./EvtAddressMap";
import lodash from "lodash"
import EventDefaultImg from "../../style/imgs/event-default.png"
import {BizRegex} from "../../services/global";


const {TextArea} = Input;
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    const loginedUser = state.loginedUser;
    return {cmEnums,loginedUser};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewBaseForm extends React.Component {
    constructor(props) {
        super(props);
        this.evtAddressMap = null;
        this.state = {
            isOnlineEvt:props.evt.header.lng == 0 && props.evt.header.lng == 0 ? true :false,
            formLoading: false,
            addressAutoCompleteDataSource: []
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
        const evt = this.props.evt;
        this.evtAddressMap.setValue({longitude: evt.header.lng, latitude: evt.header.lat}, evt.header.address);
    }
    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true)
                var _values = {...values};
                _values.customOrganizer = _values.customOrganizer ? JSON.stringify(_values.customOrganizer) : '';
                //处理活动报名起止时间
                // if (_values.time) {
                //     _values.beginTime = _values.time[0].format("YYYY-MM-DD HH:mm:ss");
                //     _values.endTime = _values.time[1].format("YYYY-MM-DD HH:mm:ss");
                // }
                // delete _values.time;
                _values.beginTime = _values.beginTime.format("YYYY-MM-DD HH:mm:ss");
                _values.endTime = _values.endTime.format("YYYY-MM-DD HH:mm:ss");
                _values.hasOwnProperty('organizers') ? null : _values.organizers=[];
                _values.hasOwnProperty('collaborators') ? null : _values.collaborators=[];
                _values.hasOwnProperty('contractors') ? null : _values.contractors=[];

                patchEventHeader(Object.assign({id: this.props.evt.header.id, userId: 1111}, _values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        this.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    addField = (fieldName, value = {}) => {
        const {form} = this.props;
        var fieldsValue = form.getFieldsValue();
        var _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        _fieldVal.push(value);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);


        form.setFieldsValue(fieldsValue);
    }


    removeField = (fieldName, index) => {
        const {form} = this.props;
        var fieldsValue = form.getFieldsValue();
        let fieldVal = lodash.get(fieldsValue, fieldName);
        let _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);
        lodash.set(fieldsValue, fieldName, fieldVal);

        form.setFieldsValue(fieldsValue);

    }

    onToggleOnlineEvt = () =>{
        const {setFieldsValue, getFieldsValue} = this.props.form;
        this.setState({
            isOnlineEvt:!this.state.isOnlineEvt
        },()=>{
            var fieldsValue = getFieldsValue();
            if(this.state.isOnlineEvt){
                lodash.set(fieldsValue, `address`, '线上活动');
                lodash.set(fieldsValue, `lng`, 0);
                lodash.set(fieldsValue, `lat`, 0);
            }else {
                lodash.set(fieldsValue, `address`, '');
                lodash.set(fieldsValue, `lng`, '');
                lodash.set(fieldsValue, `lat`, '');
            }
            setFieldsValue(fieldsValue);
        })
    }

    render() {
        const evt = this.props.evt;

        const {getFieldDecorator, getFieldValue, getFieldError, setFieldsValue, getFieldsValue, setFieldsInitialValue} = this.props.form;

        getFieldDecorator('lat', {initialValue: evt.header.lat});
        getFieldDecorator('lng', {initialValue: evt.header.lng});

        getFieldDecorator('_organizers', {initialValue: evt.header.organizers ? evt.header.organizers : []});
        getFieldDecorator('_collaborators', {initialValue: evt.header.collaborators ? evt.header.collaborators : []});
        getFieldDecorator('_contractors', {initialValue: evt.header.contractors ? evt.header.contractors : []});
        getFieldDecorator('_customOrganizer', {initialValue: evt.header.customOrganizer ? JSON.parse(evt.header.customOrganizer) : []});

        const organizers = getFieldValue('_organizers') ? getFieldValue('_organizers') : [];
        const collaborators = getFieldValue('_collaborators') ? getFieldValue('_collaborators') : [];
        const contractors = getFieldValue('_contractors') ? getFieldValue('_contractors') : [];
        const customOrganizer = getFieldValue('_customOrganizer') ? getFieldValue('_customOrganizer') : [];

        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={this.intoEdit}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>

        var amap = <EvtAddressMap
            ref={(comp) => this.evtAddressMap = comp}
            readOnly={!this.props.editable}
            location={evt.address}
            position={{longitude: evt.header.lng, latitude: evt.header.lat}}
            onChange={(lnglat, location) => {
                var fieldsValue = getFieldsValue();
                lodash.set(fieldsValue, `address`, location);
                lodash.set(fieldsValue, `lng`, lnglat.lng);
                lodash.set(fieldsValue, `lat`, lnglat.lat);
                setFieldsValue(fieldsValue);
            }}
        />


        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <div className="evt-area">

                        <div className="evt-base-area">
                            <Row>
                                <Col span={24} style={{minHeight: "600px"}}>
                                    <Card bodyStyle={{padding: "16px"}}>
                                        {editableTools}
                                        <CkInfoItem
                                            label={<span><span style={{color:"#f5222d"}}>* </span>活动名称</span>}
                                        >
                                            {
                                                this.props.editable ?
                                                    getFieldDecorator('name', {
                                                        initialValue: evt.header.name,
                                                        rules: [
                                                            {required: true, message: '活动名称为必填项'},
                                                            {whitespace:true, message: '不能输入空格!'},
                                                            {type: "string", min: 2, max: 100, message: '长度限制为2至40个之间!'}
                                                        ],
                                                    })(
                                                        <Input/>
                                                    )
                                                    :
                                                    evt.header.name
                                            }
                                        </CkInfoItem>
                                        <CkInfoItem label={<span><span style={{color:"#f5222d"}}>* </span>活动类型</span>}>
                                            {
                                                this.props.editable ?
                                                    getFieldDecorator('eventType', {
                                                        initialValue: evt.header.eventType.toString(),
                                                        rules: [{required: true, message: '请输入活动类型!'}],
                                                    })(
                                                        <Select>
                                                            {
                                                                Object.values(this.props.cmEnums.data.CmEventType).map((g, index) => {
                                                                    return <Option value={g.enumName} key={`eventtype-${index}`}>{g.enumDesc}</Option>
                                                                })
                                                            }
                                                        </Select>
                                                    )
                                                    :
                                                    this.props.cmEnums.data.CmEventType[evt.header.eventType.toString()].enumDesc
                                            }
                                        </CkInfoItem>
                                        {this.props.editable ?
                                            <div>
                                                {
                                                    organizers.map((o,index)=>{
                                                        return <CkInfoItem
                                                            key={index}
                                                            labelStyle={{display:index == 0 ? 'inline-block' : 'none'}}
                                                            label={index == 0 ? <span><span style={{color:"#f5222d"}}>* </span>主办方</span> : ''}>
                                                            {
                                                                getFieldDecorator(`organizers[${index}]`, {
                                                                    initialValue: o,
                                                                    rules: [
                                                                        {required: true, message: '主办方为必填项'},
                                                                        {whitespace:true, message: '不能输入空格!'},
                                                                        {type: "string", min: 2, max: 500, message: '长度限制为2至500个之间!'}
                                                                    ],
                                                                })(
                                                                    <Input placeholder='主办方，如：中华人民共和国科技部' style={{ width: '60%', marginRight: 8 }}/>
                                                                )

                                                            }
                                                            <Icon
                                                                className="dynamic-delete-button"
                                                                type="minus-circle-o"
                                                                disabled={organizers.length === 1}
                                                                onClick={() => this.removeField('organizers',index)}
                                                            />
                                                        </CkInfoItem>
                                                    })
                                                }
                                                <Button type="dashed" onClick={()=>this.addField('organizers','')} style={{ width: 150,marginLeft:8 }}>
                                                    <Icon type="plus" /> 添加主办方
                                                </Button>
                                            </div>
                                            :
                                            (evt.header.organizers && evt.header.organizers.length>0 &&
                                            <CkInfoItem label={<span>主办方</span>}>
                                                {evt.header.organizers.map((o,index)=><span key={index}>{o}{index !=evt.header.organizers.length-1 && '；'}</span>)}
                                            </CkInfoItem>)
                                        }

                                        {this.props.editable ?
                                            <div>
                                                {
                                                    collaborators.map((o,index)=>{
                                                        return <CkInfoItem
                                                            key={index}
                                                            labelStyle={{display:index == 0 ? 'inline-block' : 'none'}}
                                                            label={index == 0 ? "协办方" : ''}>
                                                            {
                                                                getFieldDecorator(`collaborators[${index}]`, {
                                                                    initialValue: o,
                                                                    rules: [
                                                                        {required: true, message: '协办方为必填项'},
                                                                        {whitespace:true, message: '不能输入空格!'},
                                                                        {type: "string", min: 2, max: 500, message: '长度限制为2至500个之间!'}
                                                                    ],
                                                                })(
                                                                    <Input  placeholder='协办方，如：深圳证券交易所' style={{ width: '60%', marginRight: 8 }}/>
                                                                )

                                                            }
                                                            <Icon
                                                                className="dynamic-delete-button"
                                                                type="minus-circle-o"
                                                                disabled={collaborators.length === 1}
                                                                onClick={() => this.removeField('collaborators',index)}
                                                            />
                                                        </CkInfoItem>
                                                    })
                                                }
                                                <Button type="dashed" onClick={()=>this.addField('collaborators','')} style={{ width: 150,marginLeft:8,marginTop:collaborators.length ==0 ? 8 : 0 }}>
                                                    <Icon type="plus" /> 添加协办方
                                                </Button>
                                            </div>
                                            :
                                            (evt.header.collaborators && evt.header.collaborators.length > 0 &&
                                            <CkInfoItem label={"协办方"}>
                                                {evt.header.collaborators && evt.header.collaborators.map((o,index)=><span key={index}>{o}{index !=evt.header.collaborators.length-1 && '；'}</span>)}
                                            </CkInfoItem>)
                                        }

                                        {this.props.editable ?
                                            <div>
                                                {
                                                    contractors.map((o,index)=>{
                                                        return <CkInfoItem
                                                            key={index}
                                                            labelStyle={{display:index == 0 ? 'inline-block' : 'none'}}
                                                            label={index == 0 ? "承办方" : ''}>
                                                            {
                                                                getFieldDecorator(`contractors[${index}]`, {
                                                                    initialValue: o,
                                                                    rules: [
                                                                        {required: true, message: '承办方为必填项'},
                                                                        {whitespace:true, message: '不能输入空格!'},
                                                                        {type: "string", min: 2, max: 500, message: '长度限制为2至500个之间!'}
                                                                    ],
                                                                })(
                                                                    <Input placeholder='承办方，如：中国互联网投资基金' style={{ width: '60%', marginRight: 8 }}/>
                                                                )

                                                            }
                                                            <Icon
                                                                className="dynamic-delete-button"
                                                                type="minus-circle-o"
                                                                disabled={contractors.length === 1}
                                                                onClick={() => this.removeField('contractors',index)}
                                                            />
                                                        </CkInfoItem>
                                                    })
                                                }
                                                <Button type="dashed" onClick={()=>this.addField('contractors','')} style={{ width: 150,marginLeft:8,marginTop:contractors.length ==0 ? 8 : 0 }}>
                                                    <Icon type="plus" /> 添加承办方
                                                </Button>
                                            </div>
                                            :
                                            (evt.header.contractors && evt.header.contractors.length > 0 &&
                                            <CkInfoItem label={"承办方"}>
                                                {evt.header.contractors && evt.header.contractors.map((o,index)=><span key={index}>{o}{index !=evt.header.contractors.length-1 && '；'}</span>)}
                                            </CkInfoItem>)
                                        }

                                        {this.props.editable ?
                                            <div style={{marginTop:8}}>
                                                {
                                                    customOrganizer.map((o,index)=>(
                                                        <div style={{display:'flex'}} key={index}>
                                                            <CkInfoItem
                                                                style={{ width: 150,}}
                                                                labelStyle={{display: 'none'}}>
                                                                {
                                                                    getFieldDecorator(`customOrganizer[${index}].name`, {
                                                                        initialValue: o.name,
                                                                        rules: [
                                                                            {required: true, message: '必填项'},
                                                                            {whitespace:true, message: '不能输入空格!'},
                                                                            {type: "string", min: 2, max: 500, message: '长度限制为2至500个之间!'}
                                                                        ],
                                                                    })(
                                                                        <Input placeholder='其他，如：支持单位' style={{ width: 150,}}/>
                                                                    )

                                                                }
                                                            </CkInfoItem>
                                                            <Icon
                                                                style={{marginLeft:10}}
                                                                className="dynamic-right-button"
                                                                type='caret-right' />
                                                            <CkInfoItem
                                                                style={{ flexGrow: 1,}}
                                                                labelStyle={{display: 'none'}}>
                                                                {
                                                                    getFieldDecorator(`customOrganizer[${index}].value`, {
                                                                        initialValue: o.value,
                                                                        rules: [
                                                                            {required: true, message: '必填项'},
                                                                            {whitespace:true, message: '不能输入空格!'},
                                                                            {type: "string", min: 2, max: 500, message: '长度限制为2至500个之间!'}
                                                                        ],
                                                                    })(
                                                                        <Input placeholder='内容'/>
                                                                    )

                                                                }
                                                            </CkInfoItem>
                                                            <Icon
                                                                className="dynamic-delete-button"
                                                                type="minus-circle-o"
                                                                onClick={() => this.removeField('customOrganizer',index)}
                                                            />
                                                        </div>
                                                    ))
                                                }
                                                <Button type="dashed" onClick={()=>this.addField('customOrganizer')} style={{ width: 150,marginLeft:8,marginTop:customOrganizer.length ==0 ? 8 : 0 }}>
                                                    <Icon type="plus" /> 自定义
                                                </Button>
                                            </div>
                                            :
                                            (evt.header.customOrganizer && JSON.parse(evt.header.customOrganizer).map((obj,index)=>(
                                                <CkInfoItem key={index} label={obj.name}>
                                                    <span>{obj.value}</span>
                                                </CkInfoItem>
                                            )))
                                        }



                                        <CkInfoItem label={"联系电话"}>
                                            {
                                                this.props.editable ?
                                                    getFieldDecorator('contactPhone', {
                                                        initialValue: evt.header.contactPhone ? evt.header.contactPhone.toString() : "",
                                                        rules: [
                                                            {required: false, message: '联系电话为必填项'},
                                                            {pattern: BizRegex.phone, message: '长度限制为5至20个之间，支持：数字,-,+和()'}
                                                        ],
                                                    })(
                                                        <AutoComplete addonBefore={<Icon type="phone"/>} style={{width: '100%'}}
                                                                      dataSource={this.props.loginedUser.data && this.props.loginedUser.data.mobile ? [this.props.loginedUser.data.mobile] : []}/>
                                                    )
                                                    :
                                                    evt.header.contactPhone

                                            }
                                        </CkInfoItem>


                                        <CkInfoItem label={ <span><span style={{color:"#f5222d"}}>* </span>开始时间&nbsp;
                                            <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                     mouseEnterDelay={0.3} title={
                                                <div>
                                                    三个的时间：1，活动开始时间，2，活动报名起止时间，3，活动签到起止时间  <a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/769883" target="_Blank" >  详细帮助</a>
                                                </div>
                                            }>
                                <Icon type="question-circle-o"/>
                                </Tooltip>
                                </span>}>
                                            {
                                                this.props.editable ?
                                                    <span>
                                                        {/*{*/}
                                                            {/*getFieldDecorator('time', {*/}
                                                                {/*initialValue: evt.header.beginTime ? [moment(evt.header.beginTime, 'YYYY-MM-DD HH:mm:ss'), moment(evt.header.endTime, 'YYYY-MM-DD HH:mm:ss')] : null,*/}
                                                                {/*rules: [*/}
                                                                    {/*{required: true, message: '活动时间为必填项'}*/}
                                                                {/*],*/}
                                                            {/*})(*/}
                                                                {/*<RangePicker*/}
                                                                    {/*showTime={{*/}
                                                                        {/*hideDisabledOptions: true,*/}
                                                                        {/*defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')],*/}
                                                                    {/*}}*/}
                                                                    {/*format="YYYY-MM-DD HH:mm:ss"*/}
                                                                    {/*style={{width: "325px"}}/>*/}
                                                            {/*)*/}
                                                        {/*}*/}
                                                        {getFieldDecorator('beginTime', {
                                                            initialValue:moment(evt.header.beginTime, 'YYYY-MM-DD HH:mm:ss'),
                                                            rules: [
                                                                {required: true, message: '活动时间为必填项'}
                                                            ],
                                                        })(
                                                            <DatePicker
                                                                showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                                                                placeholder="开始时间"
                                                                format="YYYY-MM-DD HH:mm:ss"
                                                                style={{width: "200px"}}
                                                            />
                                                        )}
                                                    </span>
                                                    :
                                                    evt.header.beginTime ? (evt.header.beginTime) : "未设置"
                                            }
                                        </CkInfoItem>
                                        <CkInfoItem label={<span><span style={{color:"#f5222d"}}>* </span>结束时间</span>}>
                                            {
                                                this.props.editable ?
                                                    <span>
                                                        {getFieldDecorator('endTime', {
                                                            initialValue:moment(evt.header.endTime, 'YYYY-MM-DD HH:mm:ss'),
                                                            rules: [
                                                                {required: true, message: '活动时间为必填项'}
                                                            ],
                                                        })(
                                                            <DatePicker
                                                                defaultPickerValue={moment('23:59:59', 'HH:mm:ss')}
                                                                disabledDate={endValue=>{
                                                                    const startValue = getFieldValue('beginTime');
                                                                    if (!endValue || !startValue) {
                                                                        return false;
                                                                    }
                                                                    return endValue.valueOf() <= startValue.valueOf();
                                                                }}
                                                                showTime={{ defaultValue: moment('23:59:59', 'HH:mm:ss') }}
                                                                placeholder="结束时间"
                                                                format="YYYY-MM-DD HH:mm:ss"
                                                                style={{width: "200px"}}
                                                            />
                                                        )}
                                                    </span>
                                                    :
                                                    evt.header.endTime ? (evt.header.endTime) : "未设置"
                                            }
                                        </CkInfoItem>
                                        <CkInfoItem label={<span placeholder='目前仅支持中国境内地址定位和导航'>
                                            <span style={{color:"#f5222d"}}>* </span>
                                    活动地址&nbsp;
                                            <Tooltip placement="bottom" overlayClassName='overlay-image'
                                                     mouseEnterDelay={0.3} title={
                                                <div>
                                                    文字可以编辑地址详细，在地图的定位选择可以用于导航；没有地址（国外），可以切换成线上活动 <a href="https://www.kancloud.cn/seven_qdj/qdj_detail01/769882" target="_Blank" >  详细帮助</a>
                                                </div>
                                            }>
                                <Icon type="question-circle-o"/>
                                </Tooltip>
                                </span>}>
                                            {
                                                this.props.editable ?
                                                    getFieldDecorator('address', {
                                                        initialValue: evt.header.address,
                                                        rules: [
                                                            {required: true, message: '活动地址为必填项'},
                                                            {type: "string", min: 2, max: 100, message: '长度限制为2至100个之间!'}
                                                        ],
                                                    })(
                                                        <AutoComplete
                                                            disabled={this.state.isOnlineEvt}
                                                            backfill={true}
                                                            dataSource={this.state.addressAutoCompleteDataSource}
                                                            onSelect={(val, option) => {
                                                                const location = option.props.district ? (option.props.district + option.props.address + option.props.name) : option.props.name;
                                                                console.log("onSelect", val, option);
                                                                this.evtAddressMap.setValue(option.props.location, location, true);
                                                            }}
                                                            onSearch={(searchText) => {
                                                                if (this.evtAddressMap) {
                                                                    this.evtAddressMap.autocompleteSearch(searchText, (status, result) => {
                                                                        console.log("autocompleteSearch", searchText, status, result)
                                                                        this.setState({
                                                                            addressAutoCompleteDataSource: status == "complete" ? result.tips.map(t => <Option
                                                                                key={`${t.name}${t.adcode}${t.id}`} {...t}>{t.district ? (t.district + t.address + t.name) : t.name}</Option>) : [],
                                                                        })
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            <TextArea autosize={{minRows: 1, maxRows: 2}}/>
                                                        </AutoComplete>
                                                    )
                                                    :
                                                    evt.header.address
                                            }
                                        </CkInfoItem>
                                        {this.props.editable &&
                                        (this.state.isOnlineEvt ?
                                            <a onClick={this.onToggleOnlineEvt}><Icon style={{position:'relative',top:2,fontSize:18}} type="cloud-download-o" /> 设置活动地点导航(仅支持中国地址定位和导航）</a>
                                            :
                                            <a onClick={this.onToggleOnlineEvt}><Icon style={{position:'relative',top:2,fontSize:18}} type="cloud-upload-o" /> 线上活动或地址不确定</a>
                                        )}

                                        {/* <CkInfoItem label={"活动详情文字"} contentStyle={{whiteSpace: "normal"}}>
                                            {
                                                this.props.editable ?
                                                    getFieldDecorator('summary', {
                                                        initialValue: evt.header.summary,
                                                        rules: [
                                                            {type: "string", min: 2, max: 10000, message: '长度限制为2至10000个之间!'}
                                                        ],
                                                        getValueFromEvent: (raw) => raw

                                                    })(
                                                        <EvtSummaryEditor placeholder='活动详情文字。如需使用H5模板，希望文字分页，可使用上方的「分页符」，建议260字一页' />
                                                    )
                                                    :
                                                    evt.header.summary
                                            }
                                        </CkInfoItem> */}
                                    </Card>
                                    {this.props.evtBaseAreaExtra}

                                </Col>
                            </Row>
                        </div>
                        <div className="evt-banner-area">
                            <Card bodyStyle={{padding: "16px"}}>
                                <CkInfoItem label={<span>封面（宽900x高600像素，小于4MB）</span>} contentIndent={false}>
                                    <div style={{width: "100%", height: "154px"}}>
                                        {
                                            this.props.editable ?
                                                getFieldDecorator('banner', {
                                                    initialValue: evt.header.banner,
                                                    getValueFromEvent: (fileUrlObj) => {
                                                        return fileUrlObj.url;
                                                    }
                                                })(
                                                    <CkUpload
                                                        width={238}
                                                        height={154}
                                                    />
                                                )
                                                :
                                                <img style={{width: "100%", height: "100%"}} src={evt.header.banner || EventDefaultImg}/>
                                        }
                                    </div>
                                </CkInfoItem>

                                <CkInfoItem style={{display:this.state.isOnlineEvt ? 'none' : 'block'}} label={"地图位置"} contentIndent={false}>

                                    <div style={{width: "100%", height: "200px"}}>
                                        {amap}
                                    </div>

                                </CkInfoItem>
                            </Card>
                        </div>
                    </div>
                </Spin>
            </Form>
        )
    }
}


EvtViewBaseForm.contextTypes = {}

EvtViewBaseForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "baseAreaEditable",
    evtBaseAreaExtra: null,
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewBaseForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewBaseForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewBaseForm.jsx